import {
  StyledAccordion as StyledAccordionComponent,
  StyledAccordionItem,
  StyledDetails,
  StyledSummary
} from 'components/shared/accordion/Accordion.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  padding: ${spacing('xl5')} ${spacing('md')};
  width: 100%;
  max-width: ${container('xl')};
  margin: auto;
`;

export const StyledHeader = styled.header`
  max-width: ${container('md')};
  margin: 0 auto;
  text-align: center;

  p {
    line-height: 1.5;

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('lg')};
      line-height: 1.6;
    }
  }
`;

export const StyledTabSystem = styled.div`
  max-width: ${container('lg')};
  display: none;
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl2')};

  @media (min-width: ${screen('lg')}) {
    display: flex;
  }
`;

export const StyledTabs = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  max-width: 18rem;
`;

export const StyledTab = styled.button`
  appearance: none;
  border: 0;
  border-bottom: 1px solid transparent;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  font-weight: ${fontWeight('medium')};
  text-transform: uppercase;
  font-family: inherit;
  font-size: ${fontSize('md')};
  line-height: 1.25;
  padding: ${spacing('xs')} ${spacing('md')};
  text-align: left;
  cursor: pointer;

  &.is-active {
    border-bottom-color: ${color('active')};
  }
`;

export const StyledTabNumber = styled.span`
  display: flex;
  gap: ${spacing('xs')};
  align-items: center;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('xl')};
  line-height: 1.1428;
  font-family: ${fontFamily('serif')};
  color: ${color('text_placeholder')};
  &::after {
    content: '/';
    font-weight: ${fontWeight('light')};
  }

  .is-active & {
    color: ${color('text_active')};
  }
`;

export const StyledTabContent = styled.div`
  flex-grow: 1;
  background-color: ${color('white')};
  border-radius: ${radius('md')};
  box-shadow: ${shadow('sm')};
  padding: ${spacing('xl')};

  img {
    display: block;
    margin-bottom: ${spacing('md')};
    max-height: 120px;
  }
`;

export const StyledLink = styled.a`
  padding: ${spacing('md')} ${spacing('xs')};
  display: flex;
  align-items: center;
  gap: ${spacing('md')};
  border-bottom: 1px solid ${color('midnight_200')};
`;

export const StyledAccordion = styled.div`
  background-color: ${color('white')};
  border: 1px solid ${color('midnight_200')};
  border-radius: ${radius('md')};
  overflow: hidden;
  margin-top: ${spacing('xl2')};

  @media (min-width: ${screen('lg')}) {
    display: none;
  }

  ${StyledAccordionComponent} {
    border-bottom: 0;
  }

  ${StyledAccordionItem}:first-child {
    border-top-left-radius: ${radius('md')};
    border-top-right-radius: ${radius('md')};

    ${StyledSummary} {
      border-top-left-radius: ${radius('md')};
      border-top-right-radius: ${radius('md')};
      border-top: 0;
    }
  }

  ${StyledAccordionItem}:last-child {
    border-bottom-left-radius: ${radius('md')};
    border-bottom-right-radius: ${radius('md')};

    ${StyledSummary} {
      border-bottom-left-radius: ${radius('md')};
      border-bottom-right-radius: ${radius('md')};
    }
  }

  ${StyledSummary} {
    padding: ${spacing('md')};
  }

  ${StyledDetails} {
    padding: 0 ${spacing('mdlg')};

    img {
      display: block;
      height: 4rem;
      margin: 0;
    }

    p {
      font-size: ${fontSize('sm')};
      line-height: 1.428;
    }
  }

  ${StyledLink}:last-child {
    border-bottom: 0;
  }
`;
